module.exports = __webpack_public_path__ + "static/media/image-mask-alt.e94e9f61.svg";